import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import LoadingComponent from './CommonComponents/LoadingComponent';
import './i18next';
import { initializeFirebase } from './firebase/pushNotification';

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));

const Root = () => (
  <Suspense fallback={<LoadingComponent color={'#22EBBA'} margin={2} height={27} width={27} />}>
    <App />
  </Suspense>
);

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
);

initializeFirebase();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
